const TableStatus = {
	unpublished: 0,
	new: 1,
	published: 2,
};
export default TableStatus;
